import * as  React from 'react';
import { CharConstants } from "../../constants";
import Icon from '../../../../icons';
import { isMobile } from '../../../../common/util';
const moment = require('moment');

export default class PartieCell extends React.Component {
    state = {
        isDeleteIcon: false,
        showToolTip: false
    }

    showDeleteIcon = () => {
        this.setState({
            isDeleteIcon: true
        })
    }

    hideDeleteIcon = () => {
        this.setState({
            isDeleteIcon: false
        })
    }

    isExpired(data,timezone)
    {

        if(moment.tz(moment.tz(data.expirationDate.substring(0,10), data.expirationDateTz),timezone).isSameOrBefore(moment.tz(new Date().toISOString().substring(0,10), timezone)))
        {
                return  (<div className="deActivited termExpired" onMouseEnter={()=>this.setState({showToolTip:true})} onMouseLeave={()=>this.setState({showToolTip:false})}>Term Expired
               {this.state.showToolTip &&  <div className="termInfo">
                        <div className="wrapper">
                            <div><label>Term Expired on</label> <span>{moment(data.expirationDate.substr(0,10)).format('MM/DD/YYYY')}</span></div>
                        </div>
                    </div> }
                </div>);
        }
        else
        {
            return(<div><span className="gray"></span>(Term Expiration: {moment(data.expirationDate.substr(0,10)).format('MM/DD/YYYY')})</div>)
        }
    }
    
    render(){
        const {data, extraData} = this.props;
        return(
            isMobile()? <div className='card partiesView' onClick={()=>this.props.onCellClick({eid: data.entityId, pid: data.id, type: data.entityType},data.canDeassociate)}>
            <ul className="colFlex">
                <li className="rowSpaceBetween">
                   <span>{data.partyOrg=="" ? '-' : data.partyOrg}
                    </span> { data.entityType === "wrk"  ?
                        <span className='alignMiddle'>
                            <span className="badges wkSymbol ">{CharConstants.Workkard}</span>
                            <span className="xsm ml__1 removeMob ml">
                                {data.canDeassociate && !extraData?.isAuditUser  && //why the extradata is coming null
                                    <a href="javascript:void(0);" className="" 
                                        onClick={(e) => 
                                            {
                                                e.stopPropagation();
                                                this.props.onDeleteClick({ eid: data.entityId, pid: data.id, type: data.entityType})
                                            }
                                        }>
                                        <Icon name="closeFilled" className="icon" /> 
                                    </a>
                                }
                            </span>  
                        </span>
                        :
                        <span className="badges actSymbol ">{CharConstants.Activity}</span>
                    }
                </li>
                <li>{data.partyName=="" ? '-' : data.partyName }</li>
                <li>{data.partyAddress1=="" ? '-' : data.partyAddress1}</li>
                <li>{data.partyCity=="" ? '-' : data.partyCity}</li>
                <li>{data.partyType=="" ? '-' : data.partyType}</li>
            </ul>
        </div>
            :
            
            <div className="nowWrap colFlex partiesTable">
            <ul className="nowWrap" onMouseEnter={this.showDeleteIcon} onMouseLeave={this.hideDeleteIcon} onClick={() => this.props.onItemClick(data.id,data.entityType)}>
                <li className="xsm mt">
                    { data.entityType === "wrk"  ?
                        <span className="badges wkSymbol ">{CharConstants.Workkard}</span> 
                        :
                        <span className="badges actSymbol ">{CharConstants.Activity}</span>
                    }
                </li>
                <li className="wth-4">
                    {data.partyOrg=="" ? '-' : data.partyOrg}
                </li>
                <li className="wth-4">{data.partyName=="" ? '-' : data.partyName } </li>
                <li className="wth-4">{data.partyAddress1=="" ? '-' : data.partyAddress1}</li>
                <li className="wth-2">{data.partyCity=="" ? '-' : data.partyCity}</li>
                <li className="wth-2">{data.partyType=="" ? '-' : data.partyType}</li>
                <li className="xsm">
                    {(data.canDeassociate &&  this.state.isDeleteIcon) && !extraData.isAuditUser  &&
                        <a href="javascript:void(0);" className="remove" 
                            onClick={(e) => 
                                {
                                    e.stopPropagation();
                                    this.props.onDeleteClick({ eid: data.entityId, pid: data.id, type: data.entityType})
                                }
                            }>
                            <Icon name="closeFilled" className="icon" /> 
                        </a>
                    }
                    <a href="javascript:void(0);" 
                            onClick={(e) => 
                                {
                                    e.stopPropagation();
                                    this.props.onCellClick({eid: data.entityId, pid: data.id, type: data.entityType})
                                }
                            }><Icon name="info" className="icon infoGrey" />
                  </a>
                </li>
            </ul>
            <ul>
                <li className="xsm"></li>
                <li className="wth-12">
                    <div className="rowFlex selfStart tagParties alignMiddle">
                        {!data.isActive && <div className="deActivited mr">Deactivated</div> }
                        {data.expirationDate && this.isExpired(data, extraData.wkTzValue)}
                    </div>
                </li>
            </ul>
         </div>
        );
    }
}